module.exports = __webpack_public_path__ + "static/media/integral-icon-3.e82930bb.png";